export class Coordinates{
    latitude: number;
    longitude: number;
}